<div class="title-bar">
  <h1>
    {{ "VIP_DISCOUNTS.TITLE" | translate }}
  </h1>
</div>
<nav mat-tab-nav-bar class="easy-tab mb-5" [tabPanel]="tabPanel">
  <a
    mat-tab-link
    [routerLink]="
      '/selling/prices/discounts/vip-discounts/products-and-partners'
    "
    [active]="activeLinkIndex === 0"
  >
    {{ "VIP_DISCOUNTS.TABS.PRODUCTS_AND_PARTNERS" | translate }}
  </a>
  <a
    mat-tab-link
    [routerLink]="'/selling/prices/discounts/vip-discounts/given'"
    [active]="activeLinkIndex === 1"
  >
    {{ "VIP_DISCOUNTS.TABS.GIVEN" | translate }}
  </a>
</nav>

<mat-tab-nav-panel #tabPanel>
  <router-outlet></router-outlet>
</mat-tab-nav-panel>
